import React from 'react';
import AIDatabricsPageComponent from '../components/SolutionsPage/AIDatabricsPage';

/**
 * AIDatabricsPage - AI & Databricks Solutions page wrapper
 */
export default function AIDatabricsPage() {
  return <AIDatabricsPageComponent />;
}
